import React, { FunctionComponent, useContext } from 'react';

import HeaderLayout from 'wheelspin/dist/components/Header/HeaderLayout';
import DeviceContext from 'wheelspin/dist/context/DeviceContext';
import { useGetUserStatus } from 'wheelspin/dist/graphql/user';
import isServer from 'wheelspin/dist/utils/isServer';
import { parseCookies } from 'wheelspin/dist/utils/cookiesUtils';
import ExperimentsContextProvider from 'wheelspin/dist/context/ExperimentsContext/Provider/ExperimentsContextProvider';

interface Props {
  readonly displayUserStatus: boolean;
}

const HeaderContainer: FunctionComponent<Props> = ({ displayUserStatus }) => {
  const { data, loading: isUserStatusLoading } = useGetUserStatus();
  const cookies = isServer ? {} : parseCookies(document.cookie);
  const {
    browser: { name: browser },
  } = useContext(DeviceContext);

  return (
    <ExperimentsContextProvider cookies={cookies}>
      <HeaderLayout
        browser={browser}
        cookies={cookies}
        displayUserStatus={displayUserStatus}
        hasBody
        isUserStatusLoading={isUserStatusLoading}
        userStatus={data?.userStatus}
      />
    </ExperimentsContextProvider>
  );
};

export default HeaderContainer;
